import { SMAVA_APP } from 'constants/components'

const isRegRouteinApp = (context?: string) => context === SMAVA_APP
export default isRegRouteinApp
